export default "__VITE_ASSET__sMvWfA_g__"